(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["japan-market-prompt"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = "NELPANDA:japan-store-prompt";
    const dismissDuration = 30 * 24 * 60 * 60 * 1000;
    const stayDuration = 90 * 24 * 60 * 60 * 1000;
    const promptDelay = 2000;
    const closeAnimationDuration = 350;

    class JapanMarketPrompt extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.active = true;
        this.dialog = this.querySelector("[data-japan-market-dialog]");
        if (!this.dialog || typeof window === "undefined" || typeof document === "undefined") return;
        if (window.Shopify?.designMode) return;
        if (
          !window.Shopify
          || typeof window.Shopify.routes?.root !== "string"
          || window.Shopify.routes.root === ""
          || typeof window.Shopify.country !== "string"
          || window.Shopify.country === ""
          || typeof document.baseURI !== "string"
          || typeof fetch !== "function"
        ) return;
        if (this.isDismissed()) return;

        this.dialog.addEventListener("close", () => {
          this.resetClosingState();
          this.isOpen = false;
          this.cleanupScrollLock();
        });
        this.dialog.addEventListener("cancel", (event) => {
          event.preventDefault();
          this.dismiss(dismissDuration);
        });
        this.dialog.addEventListener("click", (event) => {
          if (event.target === this.dialog) this.dismiss(dismissDuration);
        });
        this.querySelector("[data-japan-market-close]")?.addEventListener("click", () => {
          this.dismissForever();
        });
        this.querySelector("[data-japan-market-stay]")?.addEventListener("click", () => {
          this.dismiss(stayDuration);
        });
        this.querySelector("[data-japan-market-visit]")?.addEventListener("click", () => {
          this.remember(dismissDuration);
        });

        this.load();
      }

      disconnectedCallback() {
        this.active = false;
        window.clearTimeout(this.openTimer);
        this.closeDialog(true);
      }

      async load() {
        let response;
        try {
          response = await fetch(this.endpoint(), {
            headers: { Accept: "application/json" },
          });
          if (!response?.ok) return;
          const payload = await response.json();
          const isJapanDetected = payload?.detected_values?.country?.handle === "JP";
          const hasJapanSuggestion = Array.isArray(payload?.suggestions) && payload.suggestions.some(
            (suggestion) => Boolean(
              suggestion
              && suggestion.parts
              && suggestion.parts.country
              && suggestion.parts.country.handle === "JP",
            ),
          );
          if (!isJapanDetected && !hasJapanSuggestion) return;
        } catch {
          return;
        }

        if (!this.active || window.Shopify?.designMode || this.isDismissed()) return;
        this.openTimer = window.setTimeout(() => {
          if (!this.active || window.Shopify?.designMode || this.isDismissed()) return;
          this.openDialog();
        }, promptDelay);
      }

      endpoint() {
        const root = new URL(window.Shopify.routes.root, document.baseURI);
        const endpoint = new URL("browsing_context_suggestions.json", root);
        const params = new URLSearchParams();
        params.set("country[enabled]", "true");
        params.set("country[exclude]", window.Shopify.country);
        endpoint.search = params;
        return endpoint.toString();
      }

      isDismissed() {
        try {
          const storedValue = window.localStorage.getItem(storageKey);
          if (storedValue === "dismissed") return true;
          const expiresAt = Number(storedValue);
          if (Number.isFinite(expiresAt) && expiresAt > Date.now()) return true;
          if (Number.isFinite(expiresAt) && expiresAt > 0) window.localStorage.removeItem(storageKey);
        } catch {}
        return false;
      }

      remember(duration) {
        try {
          window.localStorage.setItem(storageKey, String(Date.now() + duration));
        } catch {}
      }

      rememberForever() {
        try {
          window.localStorage.setItem(storageKey, "dismissed");
        } catch {}
      }

      openDialog() {
        if (this.isOpen || this.dialog.open || this.dialog.hasAttribute("open")) return;
        try {
          if (typeof this.dialog.showModal === "function") {
            this.dialog.showModal();
          } else {
            this.dialog.setAttribute("open", "");
          }
          this.isOpen = true;
          document.documentElement.classList.add("prevent-scroll");
          this.scrollLocked = true;
        } catch {
          this.isOpen = false;
        }
      }

      dismiss(duration) {
        this.remember(duration);
        this.closeDialog();
      }

      dismissForever() {
        this.rememberForever();
        this.closeDialog();
      }

      closeDialog(immediate = false) {
        if (!this.dialog) {
          this.isOpen = false;
          this.cleanupScrollLock();
          return;
        }
        const isOpen = this.isOpen || this.dialog.open || this.dialog.hasAttribute("open");
        if (!isOpen) {
          this.isOpen = false;
          this.cleanupScrollLock();
          return;
        }

        const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
        if (immediate || reduceMotion) {
          this.finishClose();
          return;
        }
        if (this.dialog.classList.contains("is-closing")) return;

        this.dialog.classList.add("is-closing");
        this.closeAnimationEnd = (event) => {
          if (event.target !== this.dialog || event.animationName !== "np-japan-market-prompt-out") return;
          this.finishClose();
        };
        this.dialog.addEventListener("animationend", this.closeAnimationEnd);
        this.closeTimer = window.setTimeout(() => this.finishClose(), closeAnimationDuration + 100);
      }

      finishClose() {
        this.resetClosingState();
        if (typeof this.dialog.close === "function") {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute("open");
        }
        this.isOpen = false;
        this.cleanupScrollLock();
      }

      resetClosingState() {
        window.clearTimeout(this.closeTimer);
        if (this.closeAnimationEnd) {
          this.dialog?.removeEventListener("animationend", this.closeAnimationEnd);
          this.closeAnimationEnd = null;
        }
        this.dialog?.classList.remove("is-closing");
      }

      cleanupScrollLock() {
        if (!this.scrollLocked) return;
        document.documentElement.classList.remove("prevent-scroll");
        this.scrollLocked = false;
      }
    }

    if (!customElements.get("japan-market-prompt")) {
      customElements.define("japan-market-prompt", JapanMarketPrompt);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
